exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.select-error[data-v-71f31f44]{margin:0px\n}\n[data-v-71f31f44].el-table .cell{padding-bottom:10px;padding-top:10px\n}\n", "", {"version":3,"sources":["/app/frontend/src/screens/analise/components/AppLimites.vue"],"names":[],"mappings":";AA0HA,+BACE,UAAW;CACZ;AAAA,iCAGC,oBACA,gBAAiB;CAClB","file":"AppLimites.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.select-error {\n  margin: 0px;\n}\n\n/deep/.el-table .cell {\n  padding-bottom: 10px;\n  padding-top: 10px;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-71f31f44","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/screens/analise/components/AppLimites.vue
// module id = m0Et
// module chunks = 11